<section
  *ngIf="{
    banners: banners$ | async,
    selectedBanner: selectedBanner$ | async,
    canUserInteract: canUserInteract$ | async
  } as STATE"
  class="banner-selector"
>
  <div class="mat-dialog-file-upload__content-header">
    <h2>Bannières importées</h2>
  </div>
  <div class="mat-dialog-file-upload__uploadable">
    @if (!STATE.banners?.length) {
      <file-upload
        (fileChange)="addBanner($event)"
        [label]="'Faites glisser votre image/video ici.'"
        [accept]="supportedFileExtensions"
        [uploadIcon]="false"
        [uploadPreview]="false"
        [disabled]="!STATE.canUserInteract"
        [maxSize]="8_388_608"
        class="mat-dialog-file-upload__uploadable-item"
      ></file-upload>
    }

    <attachment-card
      *ngFor="let banner of STATE.banners"
      (selection)="selectBanner(banner.id)"
      [attachment]="$any(banner.data)"
      [selectable]="true"
      [unselectable]="false"
      [published]="!!banner.data.id"
      [disabled]="!STATE.canUserInteract"
      [selected]="STATE.selectedBanner?.id === banner.id"
      class="mat-dialog-file-upload__uploadable-item"
    ></attachment-card>
  </div>
</section>
